import { useEffect, useState } from "react";
import axios from "axios";
import { API, formatINR } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["created", "paid", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = () => axios.get(`${API}/admin/orders`).then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const update = async (order_id, status) => {
    await axios.patch(`${API}/admin/orders/${order_id}`, { status });
    toast.success("Order updated");
    load();
  };

  return (
    <div className="fade-in" data-testid="admin-orders-page">
      <div className="mb-10">
        <div className="font-micro text-[#8A8680] mb-3">Fulfilment</div>
        <h1 className="font-serif text-[#EDE4D3] text-5xl">Orders.</h1>
      </div>

      {orders.length === 0 ? (
        <div className="p-10 text-center font-serif text-[#8A8680] text-2xl" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
          No orders yet.
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.order_id} className="p-6 grid grid-cols-6 gap-4 items-center" style={{ background: "#141414", border: "1px solid var(--hairline)" }} data-testid={`admin-order-${o.order_id}`}>
              <div className="col-span-2">
                <div className="font-micro text-[#8A8680] mb-1">#{o.order_id.slice(0, 8)}</div>
                <div className="font-serif text-[#EDE4D3]">{o.address?.full_name || o.user_email}</div>
                <div className="font-micro text-[#8A8680] mt-1">{o.address?.city}, {o.address?.state}</div>
              </div>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Items</div>
                <div className="font-serif text-[#EDE4D3]">{o.items?.length}</div>
              </div>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Total</div>
                <div className="font-serif text-[#B8895C]">{formatINR(o.total)}</div>
              </div>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Status</div>
                <select className="input-teak" value={o.status} onChange={(e) => update(o.order_id, e.target.value)} data-testid={`admin-order-status-${o.order_id}`}>
                  {STATUSES.map((s) => <option key={s} value={s} style={{ background: "#141414" }}>{s}</option>)}
                </select>
              </div>
              <div className="font-micro text-[#8A8680]">{o.created_at?.slice(0, 10)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
